// extracted by mini-css-extract-plugin
export default {"helpIcon":"HelpIcon_helpIcon__6mFMp"};